var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DeleteIcon from "@mui/icons-material/Delete";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Box, Button, Card, CardContent, Chip, Divider, Grid, Typography, } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import React from "react";
import { Link } from "react-router-dom";
import { useCancelOwnershipInvitation, useListTeamOwnershipInvitations, } from "../api/InvitationApiProvider";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ROUTES } from "../breadcrumbs/routeConfig";
import { EmptyState } from "../common/EmptyState";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import SuccessSnackbar from "../utils/SuccessSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
export var TeamOwnershipInvitations = function () {
    var teamId = useNumericParams().id;
    var _a = useRetrieveUserTeamPermissions({ teamId: teamId }), permissions = _a.data, isPermLoading = _a.isLoading;
    var canModify = (permissions === null || permissions === void 0 ? void 0 : permissions.canModify) === true;
    var _b = useRetrieveTeam({ id: teamId, enabled: canModify }), team = _b.data, isTeamLoading = _b.isLoading, teamError = _b.error;
    var _c = useListTeamOwnershipInvitations({ teamId: teamId, enabled: canModify }), invitations = _c.data, isInvLoading = _c.isLoading, invError = _c.error;
    var _d = __read(React.useState(""), 2), successMessage = _d[0], setSuccessMessage = _d[1];
    var _e = __read(React.useState(""), 2), errorMessage = _e[0], setErrorMessage = _e[1];
    if (isPermLoading || (canModify && (isTeamLoading || isInvLoading))) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (teamError || invError || !team) {
        return _jsx(ErrorView, { error: teamError || invError });
    }
    return (_jsxs(React.Fragment, { children: [_jsxs(Grid, { container: true, spacing: 2, alignItems: "center", children: [_jsx(Grid, { item: true, xs: true, children: _jsxs(Typography, { variant: "h4", gutterBottom: true, children: ["Ownership Invitations \u2014 ", team.name] }) }), _jsx(Grid, { item: true, children: _jsx(Link, { to: ROUTES.TEAM_OWNERSHIP_INVITATIONS_SEND.replace(":id", String(teamId)), style: { textDecoration: "none" }, children: _jsx(Button, { variant: "contained", color: "primary", startIcon: _jsx(SwapHorizIcon, {}), children: "Transfer Ownership" }) }) })] }), _jsx(Divider, { sx: { my: 2 } }), invitations && invitations.length > 0 ? (_jsx(Grid, { container: true, spacing: 2, children: invitations.map(function (inv) { return (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, children: _jsx(PendingOwnershipCard, { invitation: inv, teamId: teamId, onSuccess: setSuccessMessage, onError: setErrorMessage }) }, inv.id)); }) })) : (_jsx(EmptyState, { icon: _jsx(MailOutlineIcon, {}), heading: "No pending ownership invitations", description: "Transfer ownership of this team to another user." })), _jsx(SuccessSnackbar, { open: !!successMessage, onClose: function () { return setSuccessMessage(""); }, message: successMessage }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
var PendingOwnershipCard = function (_a) {
    var invitation = _a.invitation, teamId = _a.teamId, onSuccess = _a.onSuccess, onError = _a.onError;
    var _b = __read(React.useState(false), 2), showCancel = _b[0], setShowCancel = _b[1];
    var cancelMutation = useCancelOwnershipInvitation({
        onMutate: function () { },
        onSuccess: function () {
            setShowCancel(false);
            onSuccess("Invitation cancelled.");
        },
        onError: function () {
            setShowCancel(false);
            onError("Failed to cancel invitation.");
        },
    });
    var recipientLabel = invitation.invitee
        ? "".concat(invitation.inviteeFirstName, " ").concat(invitation.inviteeLastName)
        : invitation.email || "Unknown";
    return (_jsxs(_Fragment, { children: [_jsx(DeleteDialog, { open: showCancel, title: "Cancel this ownership invitation?", onCancel: function () { return setShowCancel(false); }, onConfirm: function () {
                    return cancelMutation.mutate({
                        invitationId: invitation.id,
                        teamId: teamId,
                    });
                } }), _jsx(Card, { variant: "outlined", children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", noWrap: true, children: recipientLabel }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 1 }, children: invitation.invitee ? "Registered user" : "Invited via email" }), invitation.message && (_jsxs(Typography, { variant: "body2", sx: { mb: 1, fontStyle: "italic" }, children: ["\u201C", invitation.message, "\u201D"] })), _jsxs(Box, { sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: 1,
                            }, children: [_jsx(Chip, { label: formatDistanceToNow(new Date(invitation.createdAt), {
                                        addSuffix: true,
                                    }), size: "small", variant: "outlined" }), _jsx(Button, { size: "small", color: "error", startIcon: _jsx(DeleteIcon, {}), onClick: function () { return setShowCancel(true); }, children: "Cancel" })] })] }) })] }));
};
